import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SharedModule } from '../../../shared/shared.module';
import { ProviderMenuComponent } from './provider-menu.component';

@NgModule({
  declarations: [ProviderMenuComponent],
  imports: [SharedModule, MatIcon],
  exports: [ProviderMenuComponent],
})
export class ProviderMenuModule {}
